export default __webpack_public_path__ + "static/asana-e06afb092a316b31c3c20539621a0472.svg";